<template>
  <div>
    <div id="sub-goods-block" class="application-block sub-goods-block">
      <p class="title"><i class="fal fa-upload"></i> 상품을 업그레이드 하세요</p>
      <div class="goods-info-table-wrap lib-mt-10 upgrade_table">
        <table class="table_row_pay">
          <colgroup><col width="200px;"><col width="440px;"><col></colgroup>
          <tbody>
            <SubGoodsRowDynamicTemplate
                v-for="subGoodsCompositionInfo in subGoodsComposition"
                :select-goods-id="selectGoodsId"
                :key="subGoodsCompositionInfo.id"
                :sub-goods-composition-info="subGoodsCompositionInfo"
                :template-id="subGoodsCompositionInfo.template.id"
            />
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import SubGoodsRowDynamicTemplate from "./SubGoodsTemplate/SubGoodsRowDynamicTemplate"

export default {
  name: "SubGoodsTable",
  components: {
    SubGoodsRowDynamicTemplate
  },
  props:{
    selectGoodsId : {
      type : Number
    }
  },
  computed:{
    ...mapGetters({
      subGoodsComposition: 'goods_info/getSubGoodsComposition',
    })
  },
}
</script>

<style scoped>

</style>